const ONE_DAY = 1 as const;
const FIFTEEN_DAYS = 15 as const;
const FIRST_OF_MONTH = 1 as const;
const MID_OF_MONTH = 16 as const;

export { FIFTEEN_DAYS, FIRST_OF_MONTH, MID_OF_MONTH, ONE_DAY };
